import {createAction, props} from '@ngrx/store';

export const rootComponentOnDestroyAction =
  createAction('[NG-UNIVERSAL] Root Component OnDestroy', props<any>());
